import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";
import TypeIt from "typeit-react";
import "./AccreditationPage.scss";
import AccreditationCard from "../../components/Accreditation/AccreditationCard";
import MetaTagsSeo from "../../components/Shared/MetaTagsSeo";
import {
  containerVariants,
  cardOpsCVariants,
} from "../../styles/animationVars";
import { Link } from "react-router-dom";
function AccreditationPage() {
  return (
    <>
      <MetaTagsSeo
        title="FROI – Accreditation"
        description="FROI Accreditation is not merely a compliance milestone; it is a global declaration of Governmental Human Capital Future Readiness."
        keywords={[
          "FUTURE READY ORGANIZATION INSTITUTE",
          "Future Ready",
          "Future Ready Organization",
          "Future Ready Government",
          "Future Readiness Standards for Government Human Capital Practices",
          "Human Capital Future Readiness",
          "Future Readiness Index",
          "Government Human Capital Future Readiness Accreditation",
          "Future Readiness Accreditation",
          "Government Human Capital Future Readiness Index",
          "Future Readiness Research & Studies",
          "FROI's Future Ready Government Human Capital Model",
        ].join(", ")}
        OGDescription="FROI Accreditation is not merely a compliance milestone; it is a global declaration of Governmental Human Capital Future Readiness."
        url="https://www.froiglobal.org/"
      />{" "}
      <motion.section className="froi_section">
        {/* <section className="froi_section"> */}
        <Container>
          <div>
            <TypeIt
              element="h1"
              className="froi_title"
              options={{
                speed: 50,
                waitUntilVisible: true,
                cursor: false,
                lifeLike: true,
              }}
            >
              <strong>FROI</strong> ’s{" "}
              <span className="marked_word">Accreditation</span>™
            </TypeIt>
          </div>
          <div>
            <TypeIt
              element="h2"
              className="froi_subtitle"
              options={{
                speed: 50,
                waitUntilVisible: true,
                cursor: false,
                lifeLike: true,
              }}
            >
              FROI’s Government Human Capital Future Readiness Accreditation
            </TypeIt>
          </div>
          {/* Brand section */}
          <Row className="froi_brand_section">
            <Col lg={6} xs={12}>
              <div className="froi_brand_text">
                <p className="froi_text ">
                  As the definitive global reference for{" "}
                  <span className="no-break">future-ready</span> government
                  human capital, FROI partners with HR departments to assess,
                  accredit, and validate their entire human capital practices as
                  a <span className="no-break">Future-Ready</span> Gov Human
                  Capital Ecosystem.
                  {/* <strong>
                    <span className="marked_word">
                      The Government Human Capital Future <br />
                      Readiness Accreditation
                    </span>
                    ™
                  </strong>
                  <br />
                  Enables and accredits that the government entities operate at
                  the absolute frontier of global human capital standards;
                  ensuring enduring national future readiness. */}
                </p>
              </div>
            </Col>
            <Col lg={1} xs={1}></Col>
            <Col lg={5} xs={12}>
              <motion.div
                className="froi_brand_img"
                initial={{
                  opacity: 0,
                  x: 80,
                  scale: 0.75,
                }}
                whileInView={{
                  opacity: 1,
                  x: 0,
                  scale: 1,
                }}
                transition={{
                  duration: 1,
                  ease: [0.22, 1, 0.36, 1],
                }}
              >
                <img
                  style={{ width: "80%" }}
                  src={"./images/Accreditation/Accreditation_Logo.png"}
                  alt={"Froi_Accreditation"}
                />
              </motion.div>
            </Col>
          </Row>
        </Container>
      </motion.section>
      <section className="froi_section apply_section">
        <Container>
          <Row>
            <Col lg={5} xs={12}>
              <p className="froi_text">
                <strong>
                  FROI Accreditation is not merely a compliance milestone; it is
                  a global declaration of Governmental Human Capital Future
                  Readiness.
                </strong>{" "}
              </p>
            </Col>
            <Col lg={2} xs={12}></Col>
            <Col lg={5} xs={12}>
              <motion.div
                className="froi_apply_img"
                initial={{
                  opacity: 0,
                  x: 80,
                  scale: 0.75,
                }}
                whileInView={{
                  opacity: 1,
                  x: 0,
                  scale: 1,
                }}
                transition={{
                  duration: 1,
                  ease: [0.22, 1, 0.36, 1],
                }}
              >
                <img
                  src={
                    "./images/Accreditation/FROI_ACCREDITED_Apply_message.png"
                  }
                  alt={"Froi_Accreditation"}
                />
              </motion.div>
              <Link to="/contact" className="froi-navbar__button apply_btn">
                Apply for FROI Accreditation
              </Link>
            </Col>
          </Row>
        </Container>
      </section>
      {/* second section */}
      <section className="froi_section steps_section">
        <Container>
          <Row>
            <Col lg={6} xs={12}>
              <div className="accred_img accred_img_stages">
                <motion.img
                  initial={{ opacity: 0, x: -60 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ amount: 0.2 }}
                  transition={{
                    duration: 0.8,
                    ease: "easeOut",
                  }}
                  src="./images/Accreditation/FROI_ Accreditation_stages.png"
                  alt="Accreditation_stages"
                />
              </div>
            </Col>
            <Col lg={1} xs={1}></Col>
            <Col lg={5} xs={12}>
              <div className="accred_img accred_img_stages">
                <motion.img
                  src="./images/Accreditation/FROI_ACCREDITED_CARD_message_1.png"
                  alt="FROI accredited card message 1"
                  initial={{ opacity: 0, y: -40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ amount: 0.2 }}
                  transition={{
                    duration: 0.7,
                    delay: 0,
                    ease: "easeOut",
                  }}
                />
              </div>

              <div className="accred_img accred_img_stages">
                <motion.img
                  src="./images/Accreditation/FROI_ACCREDITED_CARD_message_2.png"
                  alt="FROI accredited card message 2"
                  initial={{ opacity: 0, y: -40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ amount: 0.2 }}
                  transition={{
                    duration: 0.7,
                    delay: 0.3,
                    ease: "easeOut",
                  }}
                />
              </div>

              <div className="accred_img accred_img_stages">
                <motion.img
                  src="./images/Accreditation/FROI_ACCREDITED_CARD_message_3.png"
                  alt="FROI accredited card message 3"
                  initial={{ opacity: 0, y: -40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ amount: 0.2 }}
                  transition={{
                    duration: 0.7,
                    delay: 0.6,
                    ease: "easeOut",
                  }}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      {/* Accreditation Cards */}
      <section className="froi_section froi-accreditation">
        <Container>
          <Row>
            <Col lg={5} xs={12}>
              <motion.div
                variants={containerVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ amount: 0.2 }}
              >
                <Row>
                  <Col lg={6} xs={12}>
                    <motion.div variants={cardOpsCVariants}>
                      <AccreditationCard
                        number={5}
                        imgSrc="./images/Accreditation/FROI_ Accreditation_card_1.png"
                        imgAlt="FROI_ Accreditation_card"
                        title="Core Dimensions"
                        description="Serving as
                         Strategic Criteria of
                        Future Readiness"
                      />
                    </motion.div>
                  </Col>
                  <Col lg={6} xs={12}>
                    <motion.div variants={cardOpsCVariants}>
                      <AccreditationCard
                        number={15}
                        imgSrc="./images/Accreditation/FROI_ Accreditation_card_2.png"
                        imgAlt="FROI_ Accreditation_card"
                        title="Strategic Pillars"
                        description="Directing Future Performance of
                        Government Human Capital Practices"
                      />
                    </motion.div>
                  </Col>
                  <Col lg={6} xs={12}>
                    <motion.div variants={cardOpsCVariants}>
                      <AccreditationCard
                        number={30}
                        imgSrc="./images/Accreditation/FROI_ Accreditation_card_3.png"
                        imgAlt="FROI_ Accreditation_card"
                        title="Standards"
                        description="Measuring Depth of
                        Human Capital
                        Performance & Readiness"
                      />
                    </motion.div>
                  </Col>
                  <Col lg={6} xs={12}>
                    <motion.div variants={cardOpsCVariants}>
                      <AccreditationCard
                        number={66}
                        imgSrc="./images/Accreditation/FROI_ Accreditation_card_4.png"
                        imgAlt="FROI_ Accreditation_card"
                        title="Guidelines & Tools"
                        description="Practical instruments to achieve and sustain
                         Gov Human Capital Future Readiness"
                      />
                    </motion.div>
                  </Col>
                </Row>
              </motion.div>
            </Col>
            <Col lg={3} xs={12}>
              <motion.div
                className="froi_arrow"
                initial={{
                  opacity: 0,
                  x: -40,
                }}
                whileInView={{
                  opacity: 1,
                  x: 0,
                }}
                viewport={{
                  amount: 0.5,
                }}
                transition={{
                  duration: 0.8,
                  delay: 1.2,
                  ease: "easeOut",
                }}
              >
                <img
                  src="./images/Accreditation/FROI_Accreditation_Arrow.png"
                  alt="FROI_Accreditation_Arrow"
                />
              </motion.div>
            </Col>
            <Col lg={4} xs={12}>
              {" "}
              <motion.div
                className="froi_brand_img"
                initial={{
                  opacity: 0,
                  x: 60,
                  scale: 0.8,
                }}
                whileInView={{
                  opacity: 1,
                  x: 0,
                  scale: 1,
                }}
                viewport={{
                  amount: 0.5,
                }}
                transition={{
                  duration: 0.9,
                  delay: 1.5,
                  ease: [0.22, 1, 0.36, 1],
                }}
              >
                <img
                  src="./images/Accreditation/Accreditation_Logo.png"
                  alt="FROI_ACCREDITED_CARD_message"
                />
              </motion.div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}

export default AccreditationPage;
